import { api } from "services/api"

interface ParsedExpressionResponse {
  parsedExpression: {
    variables: App.Pricings[]
  }
}

class ApiPricingVariables {
  async parsePricing(dataPayload: App.StrExpressionPayload) {
    const { data } = await api.post<ParsedExpressionResponse>("purchasePlan/pricing/parse", dataPayload)

    return data
  }

  async savePricingExpression(data: App.PricingPayload<App.PricingExpressionItem>, purchasePlanId: string) {
    return api.post(`purchasePlan/pricing-expression/save/${purchasePlanId}`, data)
  }

  async savePricingCalculator(data: App.PricingPayload<App.PricingCalculatorItem>, purchasePlanId: string) {
    return api.post(`purchasePlan/pricing-calculator/save/${purchasePlanId}`, data)
  }

  async getEventTypeOptions() {
    const { data } = await api.get("purchasePlan/pricing/event-types")

    return data
  }

  async calculateDevModeSummary(dataToCalculation: App.PricingVariablePayload<App.PricingExpressionSummary>) {
    const { data } = await api.post(`purchasePlan/simulation/summaryExpression`, dataToCalculation)

    return data
  }

  async calculateMonthlySummary(dataToCalculation: { monthlyPrice: number; productId: string }) {
    const { data } = await api.post(`purchasePlan/simulation/summaryMonthly`, dataToCalculation)

    return data
  }
}

export default ApiPricingVariables
